module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_NYC.6be55c5a.jpg";